<template>
  <div class="indexs">
    <Seacher></Seacher>
    <div class="index_validators">
      <IndexList>
        <template #indextit> Block height </template>
        <template #indexnum>  {{ Number(currentHeight).toLocaleString() }}  </template>
        <template #indextit1> +  {{ Number(last24hHeight).toLocaleString() }}  </template>
        <template #indexnum1> Last 24h </template>
        <template #indeximg> <img src="@/assets/m/home/1.png" /> </template>
      </IndexList>
      <IndexList>
        <template #indextit> Total Accounts </template>
        <template #indexnum>  {{ Number(totalAccounts).toLocaleString() }} </template>
        <template #indextit1>  {{ Number(activeToday).toLocaleString() }} </template>
        <template #indexnum1> active today </template>
        <template #indeximg> <img src="@/assets/m/home/2.png" /> </template>
      </IndexList>
      <IndexList>
        <template #indextit> TTOS Supply </template>
        <template #indexnum>  {{ Number(currentSupply).toLocaleString() }}</template>
        <template #indextit1>  {{ last24hSupplyPercent }} </template>
        <template #indexnum1> Last 24h </template>
        <template #indeximg> <img src="@/assets/m/home/3.png" /> </template>
      </IndexList>
      <IndexList>
        <template #indextit> TTOS Burned </template>
        <template #indexnum>  {{ Number(currentBurn).toLocaleString() }} </template>
        <template #indextit1> {{ last24hBurn }} </template>
        <template #indexnum1> Last 24h </template>
        <template #indeximg> <img src="@/assets/m/home/4.png" /> </template>
      </IndexList>
      <IndexList>
        <template #indextit> Validators </template>
        <template #indexnum>  {{ Number(validatorCount).toLocaleString() }}  </template>
        <template #indextit1>  {{ Number(nodeCount).toLocaleString() }} </template>
        <template #indexnum1> All nodes </template>
        <template #indeximg> <img src="@/assets/m/home/5.png" /> </template>
      </IndexList>
      <IndexList>
        <template #indextit>
          To the next bonus era

          <el-tooltip placement="top" popper-class="toolTipClass">
            <div slot="content">
              In the Transformers blockchain, an "era" is defined as an<br />
              incentive cycle lasting 24 hours, during which<br />
              validators must claim their rewards within the
              <br />following 24 hours after the era concludes.<br />
              Rewards not claimed within this 24-hour<br />
              timeframe will be considered invalid.
            </div>
            <img src="../../assets/m/home/tip.png" />
          </el-tooltip>
        </template>
        <template #indexnum>
          {{ theTime2 }} h {{ theTime1 }} m {{ theTime }} s
        </template>
        <template #indextit1>
          <div class="progress">
            <el-progress
              type="line"
              :percentage="Number(percentage)"
              class="el-bg-inner-running"
            ></el-progress>
          </div>
        </template>
      </IndexList>
    </div>
    <div class="index_charts">
      <div class="charts_tit">Total Transactions</div>
      <div class="charts_con"> {{ Number(totalTxCount).toLocaleString() }}  ({{ currentTPS }}TPS)</div>
      <div class="charts_botm">
        <div class="charts_l">
          <div class="charts_lt">Peak TPS (24H)</div>
          <div class="charts_lc">{{ peakTPS }}</div>
        </div>
        <div class="charts_c">
          <div class="charts_lt">Current Gas</div>
          <div class="charts_lc">{{ currentGas }}</div>
        </div>
        <div class="charts_r">
          <!-- <div class="hombottn" @click="dianji">
            <div>{{ itemname }}</div>
            <img :src="ImgUrl" />
          </div> -->
          <div class="headcontent" id="datalist" v-show="valShow">
            <ul v-for="(item, index) in calendarDatas" :key="index">
              <li
                @click="shuaixuan(item)"
                :class="index == itemindex ? 'active' : ''"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="charts">
        <div
          id="charts"
          ref="chartaa"
          style=" height: 120px;"
        ></div>
      </div>
    </div>
    <div class="index_charts">
      <div class="charts_tit">Total Staked</div>
      <div class="charts_con"> {{ Number(totalStaked).toLocaleString() }}   TTOS</div>
      <div class="charts_botm">
        <div class="charts_l">
          <div class="charts_lt">Staking Rate</div>
          <div class="charts_lc">{{ stakingRate }} %</div>
        </div>
        <div class="charts_c">
          <div class="charts_lt">
            Current APY
            <!-- <img src="../../assets/m/home/tip.png" /> -->
            <el-tooltip placement="top" popper-class="toolTipClass">
              <div slot="content">
                This value represents the current highest Annual<br/>
                            Percentage Yield (APY), with the APY for each<br/>
                            validator determined based on its own workload<br/>
                            value. Specifically, 80% of the annual rewards will<br/>
                            be directly allocated to delegators, while the<br/>
                            remaining 20% will be paid to nodes in the form of<br/>
                            commissions.<br/>
                <!-- This is the annual staking delegation reward for<br/>
                            TTOS,where 80% of the annual reward will directly<br/>
                            belong to the delegator, and the remaining 20% will<br/>
                            be paid as commission to the node. -->
                <!-- This is the annualized return on investment for<br />
                staking TTOS. Of the total, 80% of the<br />
                annualized return will directly belong to
                <br />investors, while the remaining 20% will be paid<br />
                as commission to the nodes. -->
              </div>
              <img src="../../assets/m/home/tip.png" />
            </el-tooltip>
          </div>
          <div class="charts_lc">{{ currentAPR }}%</div>
        </div>
        <div class="charts_r">
          <!-- <div class="hombottn" @click="dianji">
            <div>{{ itemname }}</div>
            <img :src="ImgUrl" />
          </div> -->
          <div class="headcontent" id="datalist" v-show="valShow">
            <ul v-for="(item, index) in calendarDatas" :key="index">
              <li
                @click="shuaixuan(item)"
                :class="index == itemindex ? 'active' : ''"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="charts">
        <div
          id="charts"
          ref="chartbb"
          style=" height: 120px"
        ></div>
      </div>
    </div>
    <!-- 列表开始 -->
    <div class="index_blocklist">
      <div class="blocktitle">
        <div class="block_latest">Latest Blocks</div>
        <div class="block_btn" @click="goPage('/m/BlockList')">
          <span> More </span> <img src="../../assets/m/home/more.png" />
        </div>
      </div>
      <div
        class="block_box"
        v-for="(item, index) in blockLists.slice(0, 4)"
        :key="item.blockHash"
      >
        <div :class="item.class == 'active' ? 'actives' : ''">
          <div class="block_tit">
            <div class="block_num" @click="goDetail('height', item.height)">
              {{ item.height }}
            </div>
            <div class="block_packer" @click="goDetail('address',item.packer)" style="display: flex;">
             <span style="color: #8d8d8d;">Packer</span> <span style="display: inline-block;width:60px; text-align: left;margin-left: 6px; overflow:hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          -o-text-overflow:ellipsis;">{{
                          item.packerName
                        }}</span
              ><img src="../../assets/m/home/more.png" />
            </div>
          </div>
          <div class="block_cont">
            <div class="block_btit">
              <div class="block_time block-time-span">{{ item.tradeTime }}</div>
              <div class="block_txn">{{ item.tradeNums }} Txns</div>
            </div>
            <div
              class="block_hash"
              @click="goDetail('blockHash', item.blockHash)"
            >
              BK Hash<span> {{ item.blockHash }}</span>
            </div>
            <div class="block_tfsc">
              <img src="../../assets/m/home/hot.png" /><span
                >{{ item.gas }} TTOS</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 列表结束 -->

  
    <div class="list">
      <div class="indexList">
        <div class="info_list">
          <div class="head">
            <div class="Trans_head">Latest Transactions</div>
            <div class="Trans_more" @click="goPage('/m/TransferList')">
              <span> More </span><img src="../../assets/m/home/more.png" />
            </div>
          </div>
          <div class="last_transaction">
            <ul class="content">
              <li
                v-for="(item, index) in transferList.slice(0, 3)"
                :key="item.txHash"
              >
                <ul :class="item.class == 'active' ? 'fadenum1' : ''">
                  <li>
                    <div>Hash</div>
                    <div class="blue" @click="goDetail('hash', item)">
                      {{ item.txHash1 }}
                    </div>
                  </li>
                  <li
                  v-if="item.type != 'Unstake' && item.fromAddress != 'Unpledge'">
                    <div>From</div>
                    <div
                      class="blue"
                      @click="
                        goDetail('address', item.fromAddress.split(',')[0])
                      "
                    >
                      {{ item.fromAddress }}
                    </div>
                  </li>

                  <li
                    v-if="
                      item.type == 'Unstake' || item.fromAddress == 'Unpledge'
                    "
                  >
                    <div>From</div>
                    <div class="black">
                      {{
                        item.fromAddress == "Unpledge"
                          ? "Unstake"
                          : item.fromAddress
                      }}
                    </div>
                  </li>
                  <li
                    v-if="   
                      item.type !=='ContractCreation' 
                    "
                  >
                    <div>To</div>
                    <div
                    v-if="item.toAddress !==''|| item.type !=='setBaseTokenURI'"
                      class="blue"
                      @click="goDetail('address', item.toAddress.split(',')[0])"
                    >
                      {{
                        item.toAddress == "Pledge" ? "Stake" : item.toAddress
                      }}
                    </div>
                    <div style="color:#8d8d8d" v-if="item.type =='setBaseTokenURI'|| item.functions=='balanceOf' || item.functions=='Contract Execute'">...</div>
                  </li>
                  <li v-if="item.type =='ContractCreation'">
                    <div>To</div>
                    <div
                   style="color: #8d8d8d;"
                      
                    >
                      ...
                    </div>
                  </li>
                  <li v-if="item.type == 'Signature Rewards'">
                    <div>To</div>
                    <div class="black">Signature Rewards</div>
                  </li>
                  <!-- <li v-if="item.type == 'Stake'">
                    <div>To</div>
                    <div class="black">Stake</div>
                  </li> -->
                  <li>
                    <div>Age</div>
                    <div class="block-time-span1 blacka">
                      {{ item.tradeTime }}
                    </div>
                  </li>
                  <li>
                    <div>Amount:</div>
                    <div class="blacka">
                       <p     v-if="
                              item.type1 == 1 ||
                              item.type1 == 2 ||
                              item.type1 == 3 ||
                              item.type1 == 4 ||
                              item.type1 == 5 ||
                              item.type1 == 'to' ||
                              item.type1 == 'from' ||
                              item.type1 == 'toAward' ||
                              item.type1 == 'commission'||
                              item.type1==99
                            ">

                            <!-- {{ new Intl.NumberFormat('en-US', {
                                  minimumFractionDigits: 0,  // 设置为足够大的值以保留所有小数位
                                  maximumFractionDigits: 10,
                                }).format(item.amount) }}  -->
                                
                                {{ item.amount }}
                                TTOS
                          </p> 
                      
                          <p
                            v-if="
                              (item.type1 == '8' && item.standard == 'ERC-20')&& item.type!=='balanceOf'
                            "
                          >
                           <span v-if="item.tokenAmount.length>8 ">{{ (Number(item.tokenAmount.slice(0,8))) }}...</span> <span v-else>{{ item.tokenAmount }}</span> {{ item.symbol }}
                          </p>
                          <!-- nft时候min铸造 -->
                          <p
                            v-if="
                             ( item.type1 == '8' && item.standard == 'ERC-721')  || item.functions!=='balanceOf'
                            "
                          >
                           <span v-if="item.type !=='setBaseTokenURI' && item.functions!=='balanceOf'">{{ item.nftNameList }}</span>  
                            <!-- <span v-if="item.tokenAmount!==''|| item.tokenAmount!==null">{{ item.tokenAmount.split(",")[0] }}</span> -->
                            <!-- {{ item.tokenAmount.split(",")[0] }} -->
                          </p>
                          <p
                            v-if="
                             ( item.type1 == '8' && item.standard == 'ERC-721' && item.symbol !=='') &&item.type =='setBaseTokenURI'|| item.functions=='balanceOf' 
                            "
                          >
                         {{ item.symbol }}
                          </p>
                          <!-- <p v-else>
                            {{ item.contractName }}
                          </p> -->
                          <p v-if="(item.type1 == '7' && item.standard=='ERC-20')">
                            <span v-if=" item.type !=='ContractCreation'">
                           <span v-if="item.tokenAmount.length>8"> {{ item.tokenAmount.slice(0,8) }}...</span><span v-else> aaa{{ item.tokenAmount }}</span></span> {{ item.symbol }}
                          </p>
                          <p v-if="item.standard=='ERC-721' && item.type1 == '7'">
                            {{ item.symbol }} 
                          </p>
                    </div>
                    <!-- <div class="blacka" v-if="item.type1 !=='7' || item.type1 !=='8'">{{ item.amount }}TTOS</div>
                    <div class="blacka" v-else>123</div> -->
                  </li>
                  <li>
                    <div>Type:</div>
                    <div class="blacka" v-if="item.type==8">{{ item.contractName }}</div>
                    <div class="blacka" v-else>{{ item.type }}</div>
                  </li>
                </ul>
              </li>
            </ul>
            <!-- <div class="button" >
              <div class="more">More</div>
              <div class="iconjian"></div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="index_content">
        <div class="dituzong">
          <!-- <div class="ditu_title">
            <span>Validators Status</span>
          </div> -->
          <div class="ditu_content">
            <img
              src="@/assets/m/home/map.png"
              id="imgs"
              style="
                width: 300px;
                height: 201px;
               
                
              "
            />
            <div class="barsBox">
              <div id="bars"></div>
            </div>
          </div>
        </div>
        <div class="ditu_vali">
          <div class="vali_li">{{ validatorCounts }}<span>Validators</span></div>
          <div class="vali_li">{{ nationCount }}<span>Countries</span></div>
          <div class="vali_li">{{ cityCount }}<span>Cities</span></div>
        </div>
        <div class="ditu_valibox">
          <div class="ditu_valiboxlist">
            <div class="ditu_tit">Current Packer</div>
            <!-- <div id="carList" style="animation: 15s"> -->
              <div class="ditu_cont">
                <div
                  v-for="(item, index) in latestPackers.slice(0, 6)"
                  :key="item.address"
                 
                  :class="
                    item.class == 'activea'
                      ? 'list ditu_conbox'
                      : 'ditu_conbox'
                  "
                >
                 
                  <img  style="width:30px;height: 30px;border-radius: 50%;" :src="item.packerLogo" />
                  <div @click="goDetail('address',item.packer)">{{ item.packerName }}</div>
                </div>
              </div>

            </div>
           
          </div>
        </div>
      </div>
      <!-- supply start -->
      <div class="supply">
        <div class="supply_box">
          <div class="supply_tit">TTOS Supply & Staking</div>
          <div class="supply_con">
            <div class="supply_ct">TTOS Supply</div>
            <div class="supply_cc">
              <div class="supply_num"> {{ Number(Supplynum).toLocaleString() }} </div>
              <div class="supply_btn">{{ last24hSupplyPercent }}</div>
            </div>
          </div>
          <div class="supply_con">
            <div class="supply_ct">Total Staked</div>
            <div class="supply_cc supply_cca">
              <div class="supply_ccs">
              <div class="supply_num">  {{ Number(Stakednum).toLocaleString() }}</div>
              <div class="supply_btny">{{  Stakedb }}%</div>
              </div>
              <div class="supply_cr">
                <!-- <div class="hombottn" @click="dianji">
                  <div>{{ itemname }}</div>
                  <img :src="ImgUrl" />
                </div> -->
                <div class="headcontent" id="datalist" v-show="valShow">
                  <ul v-for="(item, index) in calendarDatas" :key="index">
                    <li
                      @click="shuaixuan(item)"
                      :class="index == itemindex ? 'active' : ''"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
         
        </div>
        <div class="charts">
            <div
              id="charts"
              ref="charta"
              style="height: 120px"
            ></div>
          </div>
      </div>
      <!-- supply end -->
      <!-- bonus start -->
      <div class="supply">
        <div class="supply_box">
          <div class="supply_tit">Bonus & Burned</div>
          <div class="supply_con">
            <div class="supply_ct"> Total Bonus</div>
            <div class="supply_cc">
              <div class="supply_num">{{ Number(currentBonus).toLocaleString() }}</div>
              <div class="supply_btn">{{ Bonusb }}%</div>
            </div>
          </div>
          <div class="supply_con">
            <div class="supply_ct">Total Burned</div>
            <div class="supply_cc supply_cca">
            <div class="supply_ccs">
              <div class="supply_num">{{ Number(currentBurn).toLocaleString() }}</div>
              <div class="supply_btny">{{ Burnb }}%</div>
             </div>
              <div class="supply_cr">
                <!-- <div class="hombottn" @click="dianji">
                  <div>{{ itemname }}</div>
                  <img :src="ImgUrl" />
                </div> -->
                <div class="headcontent" id="datalist" v-show="valShow">
                  <ul v-for="(item, index) in calendarDatas" :key="index">
                    <li
                      @click="shuaixuan(item)"
                      :class="index == itemindex ? 'active' : ''"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
         
        </div>
        <div class="charts">
            <div
              id="charts"
              ref="chartb"
              style=" height: 120px"
            ></div>
          </div>
      </div>
      <!-- bonus end -->
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import { Search } from "vant";
import { formatSeconds, getSubStr, listType, listTypea} from "@/utils/utils";
import Seacher from "@/components/m/Seacher.vue";
import Validators from "@/components/m/Validators.vue";
import IndexList from "@/components/m/IndexList.vue";
import { GetDynamicBlock, GetHomeData, GetHomePastTradeData } from "../../assets/server/api.js";
const echarts = require("echarts");
export default {
  components: {
    Search,
    Seacher,
    Validators,
    IndexList,
    countTo,
  },
  data() {
    return {
      flog: false,
      blockLists: [],
      nowLang: "",
      chartData: [],
      activeLastPointTimer: null,
      timerOnce: null,
      ditushuju: [],
      gMapData1: [],
      ditudata: [],
      ditudatb: [],
      selectInd: 0,
      newData: [],
      newData1: [],
      newData2: [],
      timer: null,
      timer2: null,
      searchValue: "",
      data: [],
      transferList: [],
      Information: [],
      shisiday: [],
      results: [],
      shijiancha: "",
      tpsCount: 0,
      totalFlux: 0,
      validators: 0,
      stakePercent: 0,
      awardPercent: 0,
      maxGas: 0,
      allNodes: 0,
      burn: 0,
      // 倒计时开始
      nextDuring: 0, //倒计时
      theTime: 0, // 秒
      theTime1: 0, // 分
      theTime2: 0, // 时
      percentage: "", //进度条倒计时
      // 倒计时结束
      lockReconnect: false,
      sendTimeoutObj: "",
      serverTimeoutObj: "",
      totalTxCount: "",
      duration: 3000,
      startVal: 0,
      endVal: 0,
      messageId: [],
      startValarr: [],
      socket: "",
      //开始
      IsShow: false,
      valShow: false,
      itemname: "1M",
      itemindex: 0,
      ImgUrl: require("@/assets/m/home/xiala.png"),
      LogoImg: require("@/assets/pc/Index/indexlogo.png"),
      imgurl:require("@/assets/pc/Index/vers.png"),
      calendarDatas: [
        {
          name: "1M",
          value: "",
          id: 0,
        },
        {
          name: "6M",
          value: "",
          id: 1,
        },
        {
          name: "1Y",
          value: "",
          id: 1,
        },
        {
          name: "ALL",
          value: "",
          id: 1,
        },
      ],
       //首页接口开始
      currentHeight: "", //当前高度
      last24hHeight: "", //过去24小时增长的高度
      activeToday: "", //当天活跃数
      totalAccounts: "", //总账户数


      nodeCount: 2, //节点数量
      pastBurn: "", //昨天的销毁量
      pastSupply: "", // 昨天的供应量
      validatorCount: 0, // 验证器数量
      nextDuring: 0, //下一个纪元期

      //latestBlock
      latestBlock: [],
      //最新交易开始
      lastTranstion: [],
      //首页上方交易数图表和质押图表
      currentTPS: 0,
      totalTxCount: 0, // 交易总数
      peakTPS: "0", //24小时最大TPS
      currentGas: "0", //当前GAS
      totalStaked: "", // 总质押数
      stakingRate: "", //质押率
      currentAPR: "", //当前年利率
      dayalla: [],
      Transactionsnums: [],
      dayallb: [],
      Stakednums: [],
      pastdays: 30, //默认曲线图传参30,180,365,5000
      //首页最下方的曲线图片
      Supplynum: "",
      Supplynumf: "",
      Stakednum: "",
      Stakednumf: "",
      daysx: [],
      Supplynumarr: [],
      Stakednumarr: [],
      Burnednum: "",
      Burnednumf: "",
      Bonusnum: "",
      Bonusnumf: "",
      Burnednumarr: [],
      Bonusnumarr: [],
      //首页接口结束
      //首页地图开始

      cityCount: 0,
      nationCount: 0,
      validatorCounts: 0,
      latestPackers: [], //打包者
      PackerList: [],
      cityNationArr: [], //地图上的点
      baifenb:"",
      Supplyb:"",
      Stakedb:"",
      Bonusb:"",
      Burnb:"",
      //首页地图结束
      pastBurn24: "",
      currentBurn: "",
      pastBurn: "",
      currentSupply: "",
      pastSupply: "",
      pastStaked: "",
      totalStaked: "",
      currentBonus: "",
      pastBonus: "",
      pastOneDayBonus: "",
      pastTwoDayBonus: "",
      pastOneDayBurn: "",
      pastTwoDayBurn: "",
      last24hBurn: "",
      last24hSupplyPercent: "",
    };
  },

  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  watch: {
    deep: true,
    tpsCount: function (newval, oldval) {},
  },
  created() {
    sessionStorage.removeItem("tiaozhuan");
    sessionStorage.removeItem("tiaozhuan1");
    sessionStorage.removeItem("tiaozhuan2");
    sessionStorage.removeItem("tiaozhuan3");
   this.initWebSocket();
  },
  mounted() {
    // this.initChartsaa();
    // this.initChartsbb();
    // this.initChartsa();
    // this.initChartsb();
    this.shijian();
    // this.getblockinit();
    this.HomeCharts();
    this.shouye();
    // this.onMounted();
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        this.reset();
        this.start();
      }
    });
  },
  beforeDestroy() {
    if (this.activeLastPointTimer) {
      clearInterval(this.activeLastPointTimer);
    }
    if (this.timerall) {
      clearInterval(this.timerall);
    }
    if (this.timeouts) {
      clearTimeout(this.timeouts);
    }
  },
  methods: {
    shuaixuan() {},
    dianji() {
      if (this.IsShow == false) {
        this.IsShow = true;
        this.valShow = true;
        this.ImgUrl = require("@/assets/m/home/xiala.png");
      } else if (this.IsShow == true) {
        this.IsShow = false;
        this.valShow = false;
        this.ImgUrl = require("@/assets/m/home/shang.png");
      }
    },
    initChartsaa() {
      this.lineChart = echarts.init(this.$refs.chartaa);
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(36,41,49,0.8)", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            let str =
              '<span style="color:#fff;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<div style='display:flex;'>" +
              "<span style=' width:6px;height:6px;margin-top:10px;margin-right:4px; border-radius:10px;display:block;background:#00CB87;'></span>" +
              "<span style='color:#fff'>Transactions:</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              (Number( params[0].value ).toLocaleString())+
              "</span>" +
              "</div>";
            return str;
          },
        },
        grid: {
          top: "10%",
          left: "0%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          position: "left",
          show: false,
          data: this.dayalla,
          axisLine: {
            show: true, //隐藏x轴线
            lineStyle: {
              color: "#00E79A",
            },
          },
          axisTick: {
            show: true, //隐藏x轴刻度
          },
        },
        yAxis: {
            type: "value",
            min: 0,
            axisTick: {
              show: false,  //刻度线
            },
            axisLine: {
              show: false, //隐藏y轴
            },
            axisLabel: {
              show: false, //隐藏刻度值
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
              },
            },
          boundaryGap: false,
          show: false,
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // position: 'left',
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 3,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(0, 231, 154, 50)", //折线颜色, //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: this.Transactionsnums,
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    initChartsbb() {
      this.lineChart = echarts.init(this.$refs.chartbb);
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(36,41,49,0.8)", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            let str =
              '<span style="color:#fff;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<div style='display:flex;'>" +
              "<span style=' width:6px;height:6px;margin-top:10px;margin-right:4px; border-radius:10px;display:block;background:#D3F85A;'></span>" +
              "<span style='color:#fff'>Staked :</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
             
              (Number( params[0].value ).toLocaleString())+
              "</span>" +
              "</div>";
            return str;
          },
        },
        grid: {
          top: "10%",
          left: "0%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          show: false,
          data: this.dayalla,
          axisLine: {
            show: true, //隐藏x轴线
            lineStyle: {
              color: "#00E79A",
            },
          },
          axisTick: {
            show: true, //隐藏x轴刻度
          },
        },
        yAxis: {
            type: "value",  
            min: 0,
            axisTick: {
              show: false,  //刻度线
            },
            axisLine: {
              show: false, //隐藏y轴
            },
            axisLabel: {
              show: false, //隐藏刻度值
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
              },
            },
          boundaryGap: false,
          show: false,
         
       
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // position: 'left',
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 3,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#D3F85A",
                },
                {
                  offset: 0,
                  color: "#D3F85A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(211, 248, 90, 40)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#D3F85A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: this.Stakednums,
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    initChartsa() {
      this.lineChart = echarts.init(this.$refs.charta);
      let option = {
        color: ["#80FFA5", "#00DDFF"],
        tooltip: {
          trigger: "axis",
          backgroundColor: "#242931", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            console.log(params);
            let str =
              '<span style="color:#898B8D;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#00E79A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>TTOS Sypply :</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
                (Number( params[1].value ).toLocaleString())+
              "</span>" +
              "</div>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#D3F85A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>Total TTOS Staked : </span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
                (Number( params[0].value ).toLocaleString())+
              "</span>" +
              "</div>";
            return str;
          },
        },
        legend: {
          show: false,
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "2%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
           // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
            data:this.daysx,
            show: false,
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: "value",       
            min: 0,
            axisTick: {
              show: false,  //刻度线
            },
            axisLine: {
              show: false, //隐藏y轴
            },
            axisLabel: {
              show: false, //隐藏刻度值
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
              },
            },
          boundaryGap: false,
          show: false,     
          splitLine: {
            show: false,
          },
          },
        ],
        series: [
          {
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              width: 1,
              color: "#A5BF4D",
            },
            itemStyle: {
              color: "#000",
              borderColor: "#A5BF4D",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            areaStyle: {
              // opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 231, 154, 1, [
                {
                  offset: 0,
                  color: "rgba(72, 83, 32,100)",
                },
                {
                  offset: 1,
                  color: "rgb(10, 12,4, 100)",
                },
              ]),
            },
            data: this.Stakednumarr,
          },
          {
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              width: 1,
              color: "#00E79A",
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            showSymbol: false,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(3, 70, 48,100)",
                },
                {
                  offset: 1,
                  color: "rgba(0, 13, 9,100)",
                },
              ]),
            },
            data:  this.Supplynumarr,
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    initChartsb() {
      this.lineChart = echarts.init(this.$refs.chartb);
      let option = {
        color: ["#80FFA5", "#00DDFF"],
        tooltip: {
          trigger: "axis",
          backgroundColor: "#242931", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            console.log(params);
            let str =
              '<span style="color:#898B8D;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#00E79A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>TTOS Bonus :</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
                (Number( params[1].value ).toLocaleString())+
              "</span>" +
              "</div>"+
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background: #D3F85A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>Total TTOS Burned :</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
                (Number( params[0].value ).toLocaleString())+
              "</span>" +
              "</div>" ;
            return str;
          },
        },
        legend: {
          show: false,
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "2%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
           // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
            data:this.daysx,
            show: false,
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: "value",       
            min: 0,
            axisTick: {
              show: false,  //刻度线
            },
            axisLine: {
              show: false, //隐藏y轴
            },
            axisLabel: {
              show: false, //隐藏刻度值
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
              },
            },
          boundaryGap: false,
          show: false,     
          splitLine: {
            show: false,
          },
          },
        ],
        series: [
          {
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              width: 1,
              color: "#A5BF4D",
            },
            itemStyle: {
              color: "#000",
              borderColor: "#A5BF4D",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            areaStyle: {
              // opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 231, 154, 1, [
                {
                  offset: 0,
                  color: "rgba(72, 83, 32,100)",
                },
                {
                  offset: 1,
                  color: "rgb(10, 12,4, 100)",
                },
              ]),
            },
            data:this.Bonusnumarr,
           // data: [120, 282, 131, 434, 220, 340, 310],
          },
          {
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              width: 1,
              color: "#00E79A",
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            showSymbol: false,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(3, 70, 48,100)",
                },
                {
                  offset: 1,
                  color: "rgba(0, 13, 9,100)",
                },
              ]),
            },
           // data: [140, 232, 101, 264, 90, 340, 250],
           data:this.Burnednumarr,
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    mouseOver() {
      this.flog = true;
    },
    mouseLeave() {
      this.flog = false;
    },
    async shouye() {
      const data = await GetHomeData();
    //  console.log(data);
        //首页第一部分开始
        this.last24hSupplyPercent = (data.result.last24hSupplyPercent);
      this.currentHeight = data.result.currentHeight;
      this.last24hHeight = data.result.last24hHeight;
      this.totalAccounts = data.result.totalAccounts;
    //  console.log(this.totalAccounts);
      this.activeToday = data.result.activeToday;
   //   console.log(this.activeToday);
      this.currentSupply = data.result.currentSupply;
   //   console.log(this.currentSupply);
      this.pastSupply = data.result.pastSupply;
  //    console.log(this.pastSupply);
  //    console.log(parseFloat(this.currentSupply) - parseFloat(this.pastSupply));
  //    console.log(70003431.92 / parseFloat(this.pastSupply));
      this.baifenb = (
        ((parseFloat(this.currentSupply) - parseFloat(this.pastSupply)) /
          parseFloat(this.pastSupply)) *
        100
      ).toFixed(6);
      // this.baifenb = data.result.last24hSupplyPercent;
  //    console.log(this.baifenb);
      // if (this.baifenb == "Infinity") {
      //   this.baifenb = 0;
      // }
      this.currentBurn = data.result.currentBurn;
  //    console.log(this.currentBurn);
      this.pastBurn = data.result.pastBurn;
  //    console.log(this.pastBurn);
      //  this.pastBurn24=(parseFloat(this.currentBurn)-parseFloat(this.pastBurn)).toFixed(3);
      //  console.log( this.pastBurn24);

      //  this.Burnb=((parseFloat(this.currentBurn)-parseFloat(this.pastBurn))/(parseFloat(this.pastBurn))*100).toFixed(3);
  //    console.log(this.pastBurn);
      this.pastStaked = data.result.pastStaked;
  //    console.log(this.pastStaked);
      this.totalStaked = data.result.totalStaked;
 //     console.log(this.totalStaked);
      // this.Stakedb = (
      //   ((parseFloat(this.pastStaked) - parseFloat(this.totalStaked)) /
      //     parseFloat(this.totalStaked)) *
      //   100
      // ).toFixed(3);
      this.Stakedb = parseFloat(data.result.last24hStakePercent);
 //     console.log(this.Stakedb);
 //     console.log(this.totalStaked);
      this.currentBonus = parseFloat(data.result.currentBonus).toFixed(3);
 //     console.log(this.currentBonus);
      this.pastBonus = data.result.pastBonus;
 //     console.log(this.pastBonus);
      //  this.Bonusb=((parseFloat(this.currentBonus)-parseFloat(this.pastBonus))/(parseFloat(this.pastBonus))*100).toFixed(3);
      this.pastOneDayBonus = data.result.pastOneDayBonus;
      this.pastTwoDayBonus = data.result.pastTwoDayBonus;
      this.pastOneDayBurn = data.result.pastOneDayBurn;
 //     console.log(this.pastOneDayBurn);
      this.pastTwoDayBurn = data.result.pastTwoDayBurn;
      this.last24hBurn = (parseFloat(data.result.last24hBurn)).toFixed(3);
  //    console.log(this.pastTwoDayBurn);
      // this.pastBurn24=((parseFloat(this.pastOneDayBonus)-(parseFloat(this.pastTwoDayBonus));
      this.pastBurn24 = (
        parseFloat(this.pastOneDayBurn) - parseFloat(this.pastTwoDayBurn)
      ).toFixed(3);
 //     console.log(this.pastBurn24);
      // this.Bonusb = (
      //   ((parseFloat(this.pastOneDayBonus) - parseFloat(this.pastTwoDayBonus)) /
      //     parseFloat(this.pastTwoDayBonus)) *
      //   100
      // ).toFixed(3);
      this.Bonusb = (parseFloat(data.result.last24hBonusPercent)).toFixed(3);
      this.Burnb = (parseFloat(data.result.last24hBurnPercent)).toFixed(3);
      // this.Burnb = (
      //   ((parseFloat(this.pastOneDayBurn) - parseFloat(this.pastTwoDayBurn)) /
      //     parseFloat(this.pastTwoDayBurn)) *
      //   100
      // ).toFixed(3);
      this.nextDuring = data.result.nextDuring / 1000;
 //     console.log(this.nextDuring);

      this.validatorCount = data.result.validatorCount;
      this.nodeCount = data.result.nodeCount;

      //首页第一部分结束
         //Latest Blocks最新区块开始
         this.blockLists = data.result.latestBlockList;
      let strdate = Math.floor(data.result.linuxTime / 1000);
      for (let i = 0; i < this.blockLists.length; i++) {
        if (
          this.blockLists[i].packerName === "" ||
          this.blockLists[i].packerName == null
        ) {
          this.blockLists[i].packerName = this.blockLists[i].packer
        }else{
          this.blockLists[i].packerName = this.blockLists[i].packerName;
        }
        let timestampss = Math.floor(this.blockLists[i].blockTime / 1000);
        let s = strdate - timestampss;
        if (s <= 0) {
          s = 1;
        }
        this.blockLists[i].tradeTime = formatSeconds(s);
        this.newData.push(s);
      }

      //Latest Blocks结束
      //Latest Transactions最新交易开始
      this.transferList = data.result.latestTxList;
 //     console.log(this.transferList);
      for (let i = 0; i < this.transferList.length; i++) {
        if(this.transferList[i].toAddress==""){
          this.transferList[i].toAddress="-"
        }
        if(this.transferList[i].amount==""){
          this.transferList[i].amount="0";
        }
        this.transferList[i].txHash1 = getSubStr(
          this.transferList[i].txHash,
          0,
          6
        );
        if(this.transferList[i].symbol==''){
          this.transferList[i].symbol=this.transferList[i].contractName;
        }
        let timestamps = Math.floor(this.transferList[i].tradeTime / 1000);
        let ss = strdate - timestamps;
        if (ss <= 0) {
          ss = 1;
        }
        this.transferList[i].tradeTime=formatSeconds(ss);
        this.transferList[i].type1=this.transferList[i].type;
        this.transferList[i].type = listType(this.transferList[i].type);
        if( this.transferList[i].type1==8){
          this.transferList[i].type=this.transferList[i].functions;
          this.transferList[i].toAddress=this.transferList[i].toEvmAddress;
          this.transferList[i].fromAddress=this.transferList[i].fromEvmAddress;
          
        }
        
        if (this.transferList[i].type1 == 7 && this.transferList[i].standard == "ERC-721"){
          if(this.transferList[i].contractName !==''){
          this.transferList[i].symbol = this.transferList[i].contractName;}
          else{
            this.transferList[i].symbol = getSubStr(this.transferList[i].contractAddress,0,3);
          }
         //console.log(123);
        }
        if ( this.transferList[i].type1 == 8 &&  this.transferList[i].standard=="ERC-721"){
          if (this.transferList[i].nftNameList !== "") {
            this.transferList[i].nftNameList = JSON.parse(
              this.transferList[i].nftNameList
            )[0];
            this.transferList[i].symbol="";
          }else{
            // 新加的内容
            this.transferList[i].nftNameList =this.transferList[i].contractName;
            if(this.transferList[i].type1==8 && this.transferList[i].standard=='ERC-721'){
            if(this.transferList[i].contractName !==''){
              this.transferList[i].nftNameList =this.transferList[i].contractName;   
            }else{
              //this.lastTranstion[i].nftNameList = getSubStr(this.lastTranstion[i].contractAddress,0,3);  
              this.transferList[i].nftNameList =  this.transferList[i].tokenAmount;
            }
                
          }
                // 新加的内容
                // if(this.transferList[i].type1==8 && this.transferList[i].standard=='ERC-721' && this.transferList[i].symbol==''){
                //       this.transferList[i].nftNameList =this.transferList[i].contractName;
                //       console.log(1223333);
                // }
         
           }
        }
        if( this.transferList[i].type=="transferFrom" &&  this.transferList[i].nftNameList==''){
          if(this.transferList[i].contractName !==''){
          this.transferList[i].nftNameList=this.transferList[i].contractName;}else{
            this.transferList[i].nftNameList=getSubStr(this.transferList[i].contractAddress,0,3);
          }
        }
        if (
          this.transferList[i].functions == "mint" &&
          this.transferList[i].nftNameList == ""
        ) {
          if( this.transferList[i].symbol==''){
          this.transferList[i].nftNameList = this.transferList[i].tokenAmount;
          }
            
        }
        // if(this.transferList[i].type1 == 7 &&  this.transferList[i].standard=="ERC-721"){
        //   if(  this.transferList[i].contractName=" "){
        //     this.transferList[i].symbol=getSubStr(this.transferList[i].contractAddress,0,3);
        //   }

        // }
        
        //this.Time2[i] = formatSeconds(ss);
        this.newData1.push(ss);
       // console.log(this.newData1);
        // this.lastTranstion[i].type = listType(this.lastTranstion[i].type);
      }
 //     console.log(this.transferList);
        //首页地图数据
   //  console.log(data.result.mapData);
 //     console.log(data.result.mapData.cityCount);
      this.cityCount=data.result.mapData.cityCount;
     // console.log(this.cityCount);
      this.nationCount=data.result.mapData.nationCount;
      this.validatorCounts=data.result.mapData.validatorCount;
      this.latestPackers=data.result.mapData.latestPackers;
//      console.log(this.latestPackers);
      this.cityNationArr=data.result.mapData.cityNationArr;
      for(var n=0;n<this.latestPackers.length;n++){
        if(this.latestPackers[n].packerName==''){
          this.latestPackers[n].packerName=getSubStr(this.latestPackers[n].packer,0,8);
        } 
        if (this.latestPackers[n].packerLogo == "") {
          this.latestPackers[n].packerLogo = this.imgurl;
        }
      }
 //     console.log(this.latestPackers);
 //     console.log(this.cityCount);
      this.barsChartFun();

      //首页上方交易数图表和质押图表开始
      this.currentTPS = data.result.currentTPS;
      this.totalTxCount = data.result.totalTxCount;
      this.peakTPS = data.result.peakTPS;
      this.currentGas = data.result.currentGas;
  //    console.log(this.currentGas);
      this.totalStaked = data.result.totalStaked;
      this.stakingRate = ((data.result.stakingRate)*100).toFixed(3);
      this.currentAPR = (parseFloat(data.result.currentAPR)*100).toFixed(2);
 //     console.log(this.currentAPR);
      for (var m = 0; m < data.result.pastTradeDataList.length; m++) {
        this.dayalla.push(data.result.pastTradeDataList[m].pastTime);
        this.Transactionsnums.push(data.result.pastTradeDataList[m].txCount);
        this.Stakednums.push(data.result.pastTradeDataList[m].totalStaked);
      }
      // console.log(this.dayalla);
      // console.log(this.Transactionsnums);
      // console.log(this.Stakednums);
      this.initChartsaa();
      this.initChartsbb();
      this.daojishi();
      //dayalla
      //首页上方交易数图表和质押图表结束
 
    },
    qianwei(str) {
      if (str) {
        str = str.toString();
        var re = /(?=(?!(\b))(\d{3})+$)/g;
        return (str = str.replace(re, ","));
      } else {
        str = "";
      }
    },
    shijian() {
      var tblEle = document.getElementsByClassName("block-time-span");
      var tblEle1 = document.getElementsByClassName("block-time-span1");
      var that = this;
      that.timer = setInterval(() => {
        that.$nextTick(function () {
          for (var i = 0; i < that.newData.length; i++) {
            that.newData[i]++;
            if (that.newData[i] != null && tblEle[i] !== undefined) {
              tblEle[i].innerHTML =
                "<span>" + formatSeconds(that.newData[i]) + "</span>";
            }
          }
        });
      }, 1000);
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.timer);
      });
      that.timer2 = setInterval(() => {
        that.$nextTick(function () {
          for (var j = 0; j < that.newData1.length; j++) {
            that.newData1[j]++;
            if (that.newData1[j] != null && tblEle1[j] !== undefined) {
              tblEle1[j].innerHTML =
                "<span>" + formatSeconds(that.newData1[j]) + "</span>";
            }
          }
        });
      }, 1000);
      that.$once("hook:beforeDestroy", () => {
        clearInterval(that.timer2);
      });
    },
    async HomeCharts() {
      let formData = new FormData();
      let params = {
        pastdays: 30,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await GetHomePastTradeData(formData);
   //   console.log(data);
      for (var i = 0; i < data.result.length; i++) {
        //   Supplynum:"",
        // Stakednum:"",
        var lengths = data.result.length - 1;
        //console.log(lengths);
        if (lengths > 0) {
        this.Supplynum = data.result[lengths].totalSupply;
        this.Supplynumf=(((data.result[lengths].totalSupply-data.result[lengths-1].totalSupply)/data.result[lengths].totalSupply)*100).toFixed(6);
     //   console.log(this.Supplynumf);
        this.Stakednum = data.result[lengths].totalStaked;
        this.Stakednumf=(((data.result[lengths].totalStaked-data.result[lengths-1].totalStaked)/data.result[lengths].totalStaked)*100).toFixed(6);
        this.Supplynumarr.push(data.result[i].totalSupply);
        this.Stakednumarr.push(data.result[i].totalStaked);
        this.daysx.push(data.result[i].pastTime);
        this.Burnednum = data.result[lengths].totalBonus;
        this.Burnednumf=(((data.result[lengths].totalBonus-data.result[lengths-1].totalBonus)/data.result[lengths].totalBonus)*100).toFixed(6);
   //     console.log(this.Burnednumf);
        this.Bonusnum = data.result[lengths].totalBurned;
        this.Bonusnumf=(((data.result[lengths].totalBurned-data.result[lengths-1].totalBurned)/data.result[lengths].totalBurned)*100).toFixed(6);
        }
        this.Burnednumarr.push(data.result[i].totalBonus);
        this.Bonusnumarr.push(data.result[i].totalBurned);
        // Burnednum:"",
        // Bonusnum:"",
        // Burnednumarr:[],
        // Bonusnumarr:[],
        this.initChartsa();
        this.initChartsb();
      }
    },
    daojishi() {
      this.Time = setInterval(async () => {
        this.nextDuring--;
        this.percentage = (((86400 - this.nextDuring) / 86400) * 100).toFixed(
          1
        );
        this.theTime = parseInt(this.nextDuring); // 需要转换的时间秒
        this.theTime1 = 0; // 分
        this.theTime2 = 0; // 小时
        if (this.theTime > 60) {
          this.theTime1 = parseInt(this.theTime / 60);
          if (this.theTime > 1) {
            this.theTime = parseInt(this.theTime % 60);
          } else {
            this.theTime = 60;
          }
          if (this.theTime1 > 60) {
            this.theTime2 = parseInt(this.theTime1 / 60);
            if (this.theTime1 > 1) {
              this.theTime1 = parseInt(this.theTime1 % 60);
            } else {
              this.theTime1 = 60;
            }
            if (this.theTime2 > 24) {
              //大于24小时
              this.theTime2 = parseInt(this.theTime2 % 24);
            }
          }
        }
      }, 1000);
    },
    initWebSocket() {
      const that = this;
      if ("WebSocket" in window) {
      //  const wsuri = "ws://192.168.1.123:9200/tfscBrowser/websocket";
        that.socket = new WebSocket(
          "wss://explorer.tfsc.io/tfscBrowser/websocket"
        );
        // that.socket = new WebSocket(
        //   "ws://192.168.1.123:9200/tfscBrowser/websocket"
        // );
       
      } else {
        alert(" Not support websocket");
      }

      that.socket.onopen = function () {
        that.reset();
      };

      that.socket.onerror = function () {
        that.reconnect();
      };
      that.socket.onmessage = function (event) {
        that.reset();
        const data = JSON.parse(event.data);
        if (data.height == 0 && data.type == "heart") {
          that.sendTimeoutObj = setTimeout(function () {
            if (socket.readyState === 1) {
              socket.send("iphone");
            }
            that.serverTimeoutObj = setTimeout(() => {
              socket.close();
            }, 10000);
          }, 10000);
        }
        if (data.type == "currentTPS") {
          that.tpsCount = data.tpsCount;
        } else {
          that.currentTPS = data.tpsCount;
          that.maxGas = "";
          that.maxGas = data.currentGas;
       //   this.currentGas =data.currentGas;
          that.tpsCount = "";
          that.currentGas =data.currentGas;
          that.totalTxCount = data.txCount;
          that.currentHeight = data.blockHeight;
         // console.log(that.currentGas);
          that.tpsCount = data.tpsCount;
          that.messageId.unshift(data.messageId);
          that.startValarr.unshift(data.latestTxCount);
          that.messageId = that.messageId.slice(0, 2);
          that.startValarr = that.startValarr.slice(0, 2);
          if (that.messageId[1] !== data.messageId) {
            if (that.startValarr[0] > that.startValarr[1]) {
              that.startVal = that.startValarr[1];
              that.endVal = data.latestTxCount;
            }
          }

          var socketMapList = data.socketMapList;
          var txList = data.txList;

          that.blockLists = that.blockLists.slice(0, 10);
          for (var ii = 0; ii < that.blockLists.length; ii++) {
            that.blockLists[ii].class = "";
          }
          var wblockList = data.blockList;
          var strdatea = Math.floor(data.linuxTime / 1000);
          that.PackerList = [];
          for (var i = 0; i < wblockList.length; i++) {
            if(wblockList[i].packerName=='' || wblockList[i].packerName==null ){
              wblockList[i].packerName=getSubStr(wblockList[i].packer,0,8) ;
            }else{
              wblockList[i].packerName=wblockList[i].packerName;
            }
            that.PackerList.push({packerName:wblockList[i].packerName,packerLogo:wblockList[i].packerLogo,packer:wblockList[i].packer});
            wblockList[i].class = "active";
            let timestampa = Math.floor(wblockList[i].blockTime / 1000);
            var s = strdatea - timestampa;
            if (s <= 0) {
              s = 1;
            }
            that.newData.unshift(s);
            that.newData.pop();
            that.newData.slice(0, 10);
            wblockList[i].tradeTime = formatSeconds(s);
            that.blockLists.unshift(wblockList[i]);
          }
          that.transferList = that.transferList.slice(0, 10);
          for (var jj = 0; jj < that.transferList.length; jj++) {
            that.transferList[jj].class = " ";
          }

        // 打包者开始
         //    console.log( that.PackerList);
               that.latestPackers = [];
          for (var ii = 0; ii < that.PackerList.length; ii++) {
            if(that.PackerList[ii].packerLogo==""){
              that.PackerList[ii].packerLogo=that.imgurl;
            }
            // if(that.PackerList[ii].packerName==""){
            //   that.PackerList[ii].packerName= getSubStr(that.PackerList[ii].packer, 0, 3);
            // }
            // packer: "14GHF5zrZqzhtyxsH3afpMf7vpiWQGyPNp"
            //  packerName: "14GH...yPNp"
            // this.PackerList[ii].packerName= getSubStr(this.PackerList[ii],0,6);
            // console.log(this.PackerList[ii].packerName);
            that.latestPackers.unshift({
              class:"activea",
             packer: that.PackerList[ii].packer,
              packerName: that.PackerList[ii].packerName,
              packerLogo:that.PackerList[ii].packerLogo
            });
          //  this.latestPackers = (this.latestPackersa.concat(latestPackers)).slice(0,10);
          //   console.log(this.latestPackers);
          }
     //     console.log(that.latestPackers);
          // 打包者结束
          that.transferList = that.transferList.slice(0, 10);
        //  console.log(that.transferList);
          for (var jj = 0; jj < that.transferList.length; jj++) {
            that.transferList[jj].class = " ";
          }
          //   console.log(that.transferList);
     //      console.log(txList);
          for (var j = 0; j < txList.length; j++) {
            txList[j].txHash1 = txList[j].txHash;
            txList[j].type1= txList[j].type;
            txList[j].txHash1 = getSubStr(txList[j].txHash1,0,6);
            txList[j].class = "active";
            let timestampaa = Math.floor(
              that.gltimea(txList[j].tradeTime) / 1000
            ); // console.log("timestamp", timestamp);
            var ss = strdatea - timestampaa;
            if (ss <= 0) {
              ss = 1;
            }
            that.newData1.unshift(ss);
            that.newData1.pop();
            that.newData1.slice(0, 10);
            
            if (txList[j].type1 == 8) {
              txList[j].type = txList[j].functions;
              txList[j].toAddress = txList[j].toEvmAddress;
              txList[j].fromAddress = txList[j].fromEvmAddress;
            }
               //开始加的类容
             //  console.log(txList[j]);
            if (txList[j].nftNameList !== "" && txList[j].standard == "ERC-721") {
              if (typeof txList[j].nftNameList === "string" &&  txList[j].nftNameList !== "") {
                if (typeof JSON.parse(txList[j].nftNameList ) == "object") {
                  txList[j].nftNameList = JSON.parse(txList[j].nftNameList)[0];
                 }else{
                  txList[j].nftNameList = txList[j].nftNameList;
                 }
              //  console.log('字符串');
                txList[j].nftNameList = txList[j].nftNameList;
              } else if (typeof txList[j].nftNameList === "object") {
             //   console.log('对象');
                if (Array.isArray(txList[j].nftNameList)) {
                  txList[j].nftNameList = JSON.parse(txList[j].nftNameList)[0];
                }
              }
                txList[j].symbol='';
            }
            if (
              txList[j].type1 == 8 &&
              txList[j].standard == "ERC-721" &&
              txList[j].type == "mint"
            ) {
              // console.logo(txList[j]);
             // console.logo('mint走了这里');
              if (
                txList[j].nftNameList !== "" ||
                txList[j].nftNameList !== null
              ) {
                // if (typeof str == "string") {
                //   try {
                //     JSON.parse(str);
                //     return true;
                //   } catch (e) {
                //     console.log(e);
                //     return false;
                //   }
                // }
                // txList[j].nftNameList = JSON.parse(txList[j].nftNameList)[0];
                if (typeof txList[j].nftNameList === "string" &&  txList[j].nftNameList !== "") {
                txList[j].nftNameList = txList[j].nftNameList;
              } else if (typeof txList[j].nftNameList === "object") {
                if (Array.isArray(txList[j].nftNameList)) {
                  txList[j].nftNameList = JSON.parse(txList[j].nftNameList)[0];
                }
              }else{
                if( txList[j].type1==8 &&  txList[j].standard=='ERC-721' && txList[j].symbol==''){
                  if(txList[j].contractName.trim() !==''){
                  txList[j].nftNameList = txList[j].contractName;}
                  else{
                    txList[j].nftNameList=txList[j].tokenAmount;
                    //新加的
                  //  txList[j].nftNameList = getSubStr(txList[j].contractAddress,0,3);
                  }
                }
              }
                txList[j].symbol = "";
              }

              if (txList[j].symbol == "") {
                txList[j].symbol = txList[j].contractName;
              }
              // if(this.txList[j].symbol==''){
              //   this.txList[j].symbol=this.txList[j].contractName;
              // }
            }
            if ((txList[j].type1 == 8 && txList[j].standard == "ERC-721")&& txList[j].type=='setBaseTokenURI') {
              if(txList[j].symbol==''){
                  txList[j].symbol=txList[j].contractName;
                }
            }
            if ((txList[j].type1 == 8 && txList[j].standard == "ERC-721")&& txList[j].type=='transferFrom') {
              if (txList[j].nftNameList == "") {
                if(txList[j].contractName !==''){
                  txList[j].nftNameList = txList[j].contractName;
                }else{
                  txList[j].nftNameList =  txList[j].tokenAmount;
                }
              }
            }
            //为特殊类型的时候
            if ((txList[j].type1 == 8 && txList[j].standard == "ERC-721")&& txList[j].functions=='Contract Execute') {
            //  console.log('走这里');
              if (txList[j].nftNameList == "") {
                if(txList[j].contractName.trim() !==''){
                  txList[j].nftNameList = txList[j].contractName;
                }else{
                  txList[j].nftNameList =  txList[j].tokenAmount;
                }
              }
            }
           // console.log(txList[j]);
            if(txList[j].type1 == 7 && txList[j].standard == "ERC-721"){
               if(txList[j].symbol.trim()==''){
               txList[j].symbol=getSubStr(txList[j].contractAddress,0,3);
               }
            }
         //  if (txList[j].type1 == 7 && txList[j].standard == "ERC-721") {
            if (txList[j].type1 == 7 && txList[j].standard == "ERC-721"){

              
                if(txList[j].contractName !==''){
                  txList[j].symbol = txList[j].contractName;}
                else{
                  txList[j].symbol = getSubStr(txList[j].contractAddress,0,3);
                }
         //console.log(123);
      //  }
            // if (txList[j].nftNameList == "") {
              
            //     if(txList[j].symbol.trim()==''){
            //       if(txList[j].contractName.trim() !==''){
            //         txList[j].symbol=txList[j].contractName;
            //       }else{
            //         txList[j].symbol=getSubStr(txList[j].contractAddress,0,3);
            //       }
            //    }
            //   }
            }
            if (txList[j].type1 == 8 && txList[j].standard == "ERC-721") {
              if(txList[j].symbol==''){
         //       console.log(11111);
                  txList[j].symbol=txList[j].contractName;
              }else{
                txList[j].symbol=txList[j].symbol;
              }
            }
            // console.log(that.newData1);
           txList[j].tradeTime = formatSeconds(ss);
            that.transferList.unshift(txList[j]);
            txList[j].type = listType(txList[j].type);
       //     console.log(that.transferList);
          }

   
          that.ditudata = socketMapList;
          that.gMapData1 = [];
          that.result = [];
          that.barsChartFun();
          that.ditudatb = socketMapList;
          // var boxlist = document.getElementById("carList");
          // if (that.ditudatb.length > 0) {
          //   boxlist.style.animation = "15s";
          //   that.timeouts = setTimeout(function () {
          //     boxlist.style.animation = "marquee 15s linear 1";
          //   }, 30);
          // }
          // for (var i = 0; i < that.ditudatb.length; i++) {
          //   if (that.ditudatb[i].class == undefined) {
          //     that.ditudatb[i].class = "activea";
          //   }
          //   if ((that.ditudatb[i].name = " ")) {
          //     that.ditudatb[i].name = "Unknown";
          //   }
          //   that.ditudatb[i].address1 = that.ditudatb[i].address;
          //   that.ditudatb[i].address1 = getSubStr(
          //     that.ditudatb[i].address1,
          //     0,
          //     6
          //   );
          //   let timestampa = Math.floor(
          //     that.gltimea(that.ditudatb[i].tradeTime) / 1000
          //   );
          //   var sss = strdatea - timestampa;
          //   if (sss <= 0) {
          //     sss = 1;
          //   }
          //   that.ditudatb[i].tradeTime = formatSeconds(sss);
          //   that.Information.unshift(that.ditudatb[i]);
          //   that.Information.pop();
          // }
        }
      };

      that.socket.onclose = function (e) {
        // console.log(
        //   "websocket : " + e.code + " " + e.reason + " " + e.wasClean
        // );

        that.reconnect();
      };
      window.onbeforeunload = function () {
        that.socket.close();
      };
    },

    reconnect() {
      let that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      setTimeout(function () {
        that.lockReconnect = false;
        that.initWebSocket();
      }, 5000);
    },
    reset() {
      clearTimeout(this.sendTimeoutObj);
      clearTimeout(this.serverTimeoutObj);
    },

    start() {
      let that = this;
      that.sendTimeoutObj = setTimeout(function () {
        that.socket = new WebSocket(
          "wss://explorer.tfsc.io/tfscBrowser/websocket"
        );
        if (that.socket.readyState === 1) {
          that.socket.send("iphone");
        }
        that.serverTimeoutObj = setTimeout(() => {
          that.socket.close();
        }, 10000);
      }, 10000);
    },
    onMounted() {
      // const marquee = document.getElementById("carList");
      // marquee.innerHTML = marquee.innerHTML + marquee.innerHTML;
    },


    goPage(url) {
      this.$router.push(url);
    },
    async barsChartFun() {
      this.myChart = this.$echarts.init(document.getElementById("bars"));
      var gMapData = this.ditudata;
  //    console.log(gMapData);
      this.gMapDataa = this.cityNationArr;
   //   console.log(this.gMapDataa);
      var jieguo = [];
      for (var i = 0; i < this.gMapDataa.length; i++) {
        this.gMapDataa[i].dindex = i;
        for (var j = 0; j < gMapData.length; j++) {
          if (
            this.gMapDataa[i].latitude === gMapData[j].latitude &&
            this.gMapDataa[i].longitude === gMapData[j].longitude
          ) {
            jieguo.push(this.gMapDataa[i]);
          }
        }
      }
      let newList4 = [];
      jieguo.forEach((item) => {
        if (newList4.indexOf(item) === -1) {
          newList4.push(item);
        }
      });
  //  console.log(newList4);
      var dataindexs = [];
      for (var ii = 0; ii < newList4.length; ii++) {
        dataindexs.push(newList4[ii].dindex);
      }
      var option;
      option = {
        confine: true,
        backgroundColor: "rgba(255,255,255,0)",
        tooltip: {
          formatter: function (params) {
    //        console.log(params.value[3]);
    //        console.log(params.value[2]);

            let str = "";
            for (var i = 0; i < params.value[2].length; i++) {
              str += `<div style='color:#959799;font-size:12px;'> ${params.value[3]}, ${params.value[2][i].cityName}<span style="color:#fff;"> ${params.value[2][i].count} Nodes</span></div>`;
            }
            return str;
          },
        },
        geo: {
          type: "map",
          show: true,
          top: 10,
          bottom: 10,
          map: "world",
          roam: false,
          aspectScale: 0.55,
          zoom: 1.3,
          label: {
            emphasis: {
              show: false,
            },
          },
          itemStyle: {
            normal: {
              areaColor: {
                image: document.getElementById("imgs"),
                // Image:require("@/assets/pc/Index/map.png"),
                // image: dot, // 支持为 HTMLImageElement, HTMLCanvasElement，不支持路径字符串
                repeat: "repeat", // 是否平铺，可以是 'repeat-x', 'repeat-y', 'no-repeat'
              },
              color: "rgb(31,37,119)",
              borderColor: "#000",
              borderWidth: 0,
            },
            emphasis: {
              areaColor: "none",
              label: {
                show: false,
              },
            },
          },
        },
        series: [
          {
            type: "scatter",
            zlevel: 1,
            coordinateSystem: "geo",
            symbolSize: 25,
            symbolSize: function (val) {
     //          console.log(val);
     //         console.log(val[2]);
              if((val[2]!=="undefined")){
              let price = val[2].reduce(
                (sum, e) => sum + Number(e.count || 0),
                0
              );
       //       console.log(price);
              

              var length = price.toString().length;
        //      console.log(length);
              }
              if (length == 0) {
                return 10;
              } else if (length == 1) {
                return 10;
              } else if (length == 2) {
                return 15;
              } else if (length == 3) {
                return 20;
              } else if (length == 4) {
                return 25;
              }
            },

            itemStyle: {
              normal: {
                color: "#00E79A",
               
              },
            },
            data: this.gMapDataa.map(function (itemOpt) {
       //       console.log(itemOpt);
              return {
                name: itemOpt.num,
                value: [
                  itemOpt.longitude,
                  itemOpt.latitude,
                  itemOpt.cityList,
                  itemOpt.nationName,
                ],
                label: {
                  normal: {
                    show: true,
                    position: "inside",
                    formatter: "{b}",
                    textStyle: {
                      color: "rgba(255,255,255,0.9000)",
                      fontWeight: "100",
                      position: "left",
                      left: 10,
                      fontSize: 11,
                    },
                  },
                },
                showEffectOn: "render",
                rippleEffect: {
                  brushType: "stroke",
                },
                hoverAnimation: true,
              };
            }),
          },
          {
            type: "effectScatter",
            animation: false,
            zlevel: 2,
            coordinateSystem: "geo",
            legendHoverLink: true,
            hoverAnimation: true,
            effectType: "ripple",
            showEffectOn: "render",
            rippleEffect: {
              period: 2.5,
              scale: 2.5,
              brushType: "stroke",
            },
            symbolSize: function (val) {
     //         console.log(val);
              let price = val[2].reduce(
                (sum, e) => sum + Number(e.count || 0),
                0
              );
      //        console.log(price);
              //               var sum;
              //               val[2].forEach(item =>{
              // sum += item;
              // });
              //     console.log(sum);

              var length = price.toString().length;
              // var length = val[2].toString().length;
              if (length == 0) {
                return 10;
              } else if (length == 1) {
                return 10;
              } else if (length == 2) {
                return 15;
              } else if (length == 3) {
                return 20;
              } else if (length == 4) {
                return 24;
              }
            },
            itemStyle: {
              normal: {
                color: "#00E79A",
              },
            },
            data: newList4.map(function (itemOpt) {
              return {
                name: itemOpt.num,
                value: [
                  itemOpt.longitude,
                  itemOpt.latitude,
                  itemOpt.cityList,
                  itemOpt.nationName,
                  // itemOpt.num,
                  // itemOpt.city,
                  //  itemOpt.dindex,
                ],
                label: {
                  normal: {
                    show: true,
                    position: "inside",
                    formatter: "{b}",
                    textStyle: {
                      color: "rgba(255,255,255,0.9000)",
                      fontWeight: "100",
                      fontSize: 11,
                    },
                  },
                },
                zlevel: 3,
                showEffectOn: "render",
                rippleEffect: {
                  brushType: "stroke",
                },
                hoverAnimation: true,
              };
            }),
          },
        ],
      };
     // this.myChart.clear();
      option && this.myChart.setOption(option);
    },
   
   goDetail(name, query) {
  //    console.log(query);
      switch (name) {
        case "address":
          this.$router.push({
            path: "/m/Address",
            query: { address: query },
          });
          break;
        case "blockHash":
          this.$router.push({
            path: "/m/BlockDetails",
            query: { blockHash: query },
          });
          break;
        case "hash":
          this.$router.push({
            path: "/m/TransferDetails",
            query: {
              txHash: query.txHash,
              type: query.type1,
              standard: query.standard,
            },
           // query: { txHash: query.txHash,type:query.type1, standard:query.standard },
          });
          break;
        case "height":
          this.$router.push({
            path: "/m/BlockHeight",
            query: { height: query },
          });
          break;
        case "verifier":
          this.$router.push({
            path: "/m/VerifierDetail",
            query: { id: query },
          });
          break;
      }
    },

    gltimea(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
  },
  destroyed() {
   // this.socket.close();
    this.$router.go(0);
  },
};
</script>
<style scoped>
.progress {
  width: 654px;
}
.el-progress {
  display: flex;
  margin-top: 4px;
}

.progress ::v-deep.el-progress-bar__outer {
  border-radius: 317px 317px 317px 317px !important;
  border: none;
  width: 654px;
  height: 24px !important;
  background: #13161b;
  opacity: 1;
}

.progress ::v-deep .el-bg-inner-running .el-progress-bar__inner {
  border-radius: 317px 317px 317px 317px;
  background-color: unset;
  height: 24px;
  background-image: linear-gradient(to right, #00e79a, #00e79a);
}
</style>
<style lang="less">
.el-progress__text{
  display: none;
}
.list-container {
  // margin-top: 6px;
  width: 624px;
  height: 1160px;
  margin-left: 13px;
  overflow: hidden;
  position: relative;
  // border: 1px solid red;
  .list-item {
    display: flex;
    border-bottom: 1px solid #3c485c;
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    .item-name {
      height: 56px;
      line-height: 56px;
    }
    .item-name:nth-child(1) {
      width: 245px;
      .changdu {
        width: 200px;
        word-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .item-name:nth-child(2) {
      width: 190px;
    }
    .item-name:nth-child(3) {
      color: #9567fb;
      margin-left: 16px;
    }
  }
}
#carList {
  width: 630px;
  height: 240px;
  // margin-left: 13px;
  // overflow: hidden;
  position: relative;
}
.marquee {
  //animation-delay: -5s;
  animation: marquee 15s linear 1;
}
.marquee:hover {
  animation-play-state: paused;
}
@keyframes marquee {
  from {
    left: 0;
    top:-56px;
  }

  to {
    left: 0px;
    top: 0;
  }
}
.fadenum1 {
  color: #000;
  animation: fadenum112 3s 1;
}

@keyframes fadenum112 {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  30% {
    opacity: 0.3;
  }
  40% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.5;
  }
  60% {
    opacity: 0.6;
  }
  70% {
    opacity: 0.7;
  }
  80% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}
.actives {
  color: #000;
  animation: fadenum112 3s 1;
  // -webkit-animation: actives 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  // animation: actives 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  // will-change: transform, opacity, width;
}
@keyframes actives {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  30% {
    opacity: 0.3;
  }
  40% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.5;
  }
  60% {
    opacity: 0.6;
  }
  70% {
    opacity: 0.7;
  }
  80% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}
.indexList {
  width: 100%;
  background: #13161b;
  .el-icon-arrow-right {
    color: #e4e4e4;
  }
  margin-top: 34px;
  .info_list {
    width: 702px;
    height: 1415px;
    background: #000000;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    //  border-radius: 0px 0px 16px 16px;
    //   opacity: 1;
    .head {
      width: 686px;
      height: 48x;
      opacity: 1;
      padding-left: 30px;
      text-align: left;
      font-size: 30px;
      font-family: "PingFang SC-中粗体, PingFang SC";
      font-weight: normal;
      color: #ffffff;
      margin-top: 32px;
      margin-bottom: 18px;
      display: flex;
      justify-content: space-between;
      .Trans_head {
        height: 42px;
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #8a8a8a;
        line-height: 42px;
      }
      .Trans_more {
        width: 127px;
        height: 44px;
        line-height: 44px;
        background: #242931;
        border-radius: 13px 13px 13px 13px;
        opacity: 1;
        display: flex;
        img{
          width: 46px;
          height: 46px;
        }
        span {
          font-size: 24px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          margin-left: 20px;
        }
      }
    }
    .last_transaction {
      width: 100%;
      height: auto;
      margin-bottom: 20px;
      .subject {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        div:nth-child(1) {
          height: 39px;
          font-size: 28px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #8a8a8a;
          line-height: 39px;
        }
        div:nth-child(2) {
          font-size: 28px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 39px;
        }
      }
      .content {
        width: 100%;
        margin: 0 auto;
        ul {
         // border-bottom: 1px solid #13161b;
         border-bottom: 1px solid #13161b;
          margin: 0 32px;
        }
        // ul:nth-child(3){
        //   border-bottom:1px solid yellow;
        // }
      }
      .content > li {
        width: 100%;
        height: 438px;
        display: flex;
        align-items: center;
        .blue {
          color: #00a870;
        }
        ul {
          width: 100%;
          height: 95%;

          li:nth-child(1) {
            height: 44px;
            line-height: 44px;
          }

          li:nth-child(6) {
            margin-top: 20px;
          }
          li {
            display: flex;
            flex-direction: row;
            // align-items: center;
            margin-top: 16px;
            height: 44px;
            justify-content: space-between;

            div:nth-child(1) {
              width: 170px;
              text-align: left;
              height: 39px;
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              line-height: 39px;
            }
            div:nth-child(2) {
              height: 39px;
              font-size: 28px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              line-height: 39px;
              text-align: right;
            }
           
            .blue {
              text-align: left;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              width: 420px;
            }
            .black {
              color: #e4e4e4 !important;
            }
            .blacka {
              color: #8a8a8a !important;
            }
          }
          .blue {
            color: #00a870;
          }
        }
      }
      .button {
        height: 100px;
        line-height: 100px;

        display: flex;
        align-content: center;
        justify-content: center;
        color: rgba(255, 255, 255, 0.55);
        .more {
          height: 60px;
          line-height: 60px;
          margin-top: 32px;
          margin-bottom: 36px;
          font-size: 28px;
        }
        .iconjian {
          width: 24px;
          height: 24px;
          margin-top: 51px;
          margin-bottom: 36px;
          border-top: 2px solid rgba(255, 255, 255, 0.55);
          border-right: 2px solid rgba(255, 255, 255, 0.55);
          transform: rotate(45deg);
          transform: rotate(45deg);
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.indexs {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;
  .lunbo {
    width: 750px;
    // height: 310px;
    margin-top: 48px;
    .lunbo_c {
      // margin: 24px 30px 2px 32px;
      height: 48px;
      line-height: 48px;
      margin-left: 32px;
      display: flex;
      align-content: center;
      justify-content: space-between;
      .lunleft {
        // width: 180px;
        height: 48px;
        font-size: 32px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.9);
        line-height: 48px;
      }

      .button {
        height: 70px;

        display: flex;
        align-content: center;
        justify-content: center;
        color: rgba(255, 255, 255, 0.55);
        .more {
          height: 48px;
          line-height: 48px;
          font-size: 24px;
        }
        .iconjian {
          width: 24px;
          height: 24px;
          margin-top: 12px;
          border-top: 2px solid rgba(255, 255, 255, 0.55);
          border-right: 2px solid rgba(255, 255, 255, 0.55);
          transform: rotate(45deg);
          transform: rotate(45deg);
          margin-right: 32px;
        }
      }
    }
    .resume-list {
      width: 690px;
      margin: 0 auto;
      .pool_main {
        width: 100%;
      }
      .tags {
        display: flex;
        overflow: auto;
        padding: 10px 0 10px 0;
        white-space: nowrap;
        padding-left: 6px;
      }

      .tags::-webkit-scrollbar {
        display: none;
      }

      .indexList1 {
        width: 100%;
        .el-icon-arrow-right {
          color: #e4e4e4;
        }
        .info_list1 {
          width: 690px !important;
          height: auto;
          margin: 0 auto;
          display: flex;
          flex-direction: column;

          .last_transaction {
            width: 100%;
            height: auto;
            margin-bottom: 20px;
            .content {
              width: 100%;
              margin: 0 auto;
              display: flex;
              width: 1960px !important;
            }
            .content > li {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-right: 20px;
              width: 1960px !important;
              height: 200px;
              background: #2c3645;
              border-radius: 10px 10px 10px 10px;

              align-items: center;
              .blue {
                color: #00a870;
              }
              ul {
                width: 100%;
                height: 100%;

                li {
                  display: flex;
                  .item1 {
                    display: flex;
                    margin-left: 24px;
                    margin-top: 24px;
                    .ys {
                      width: 180px;
                      height: 48px;
                      font-size: 32px;
                      font-family: SF Pro Text-Medium, SF Pro Text;
                      font-weight: 500;
                      color: #00a870;
                      line-height: 48px;
                      text-align: left;
                    }
                    span {
                      margin-right: 20px;
                      height: 40px;
                      font-size: 24px;
                      // font-family: SF Pro Text-Medium, SF Pro Text;
                      font-weight: 500;
                      color: rgba(255, 255, 255, 0.9);
                      line-height: 40px;
                    }
                  }
                  .item2 {
                    display: flex;
                    margin-left: 24px;
                    margin-top: 8px;
                    span {
                      height: 40px;
                      font-size: 24px;
                      font-weight: 400;
                      color: rgba(255, 255, 255, 0.55);
                      line-height: 40px;
                      margin-right: 32px;
                    }
                    span:nth-child(2) {
                      font-size: 24px;
                      font-family: SF Pro Text-Regular, SF Pro Text;
                      font-weight: 400;
                      color: rgba(255, 255, 255, 0.55);
                    }
                  }
                  .item3 {
                    display: flex;
                    margin-left: 24px;
                    margin-top: 16px;
                    span {
                      width: 94px;
                      height: 40px;
                      font-size: 24px;
                      margin-right: 5px;
                      font-weight: 400;
                      color: rgba(255, 255, 255, 0.9);
                      line-height: 40px;
                    }
                    .ys {
                      width: 300px;
                      height: 40px;
                      font-size: 24px;
                      font-weight: 400;
                      color: #00a870;
                      line-height: 40px;
                      margin-left: 24px;
                      margin-right: 30px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .index_content {
    width: 750px;
    background: #000;
    border-radius: 0px 0px 0px 0px;
    text-align: center;
    // .echartss {
    //   margin: 0 auto;
    //   width: 686px;
    //   height: 558px;
    //   background: #2c3645;
    //   border-radius: 16px 16px 0px 0px;
    //   opacity: 1;
    //   .charts {
    //     width: 686px !important;
    //     height: 558px !important;
    //     margin: 0 auto;
    //     border:1px solid red;
    //     canvas {
    //       margin: 0 auto;
    //       width: 670px !important;
    //       height: 430px !important;
    //     }
    //   }
    // }
  }
  .supply {
    width: 702px;
    height: 531px;
    background: #000000;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    margin: 0 auto;
    margin-top: 24px;
    .supply_box {
      padding-top: 28px;
      margin-left: 24px;
      text-align: left;
      .supply_tit {
        height: 43px;
        font-size: 30px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #8a8a8a;
        line-height: 43px;
      }
      .supply_con {
        margin-top: 24px;
        .supply_ct {
          height: 34px;
          font-size: 24px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #8a8a8a;
          line-height: 34px;
        }
        .supply_cca{
          justify-content: space-between;
        }
        .supply_cc {
          display: flex;
        .supply_ccs{
          display: flex;
        }
          .supply_num {
            height: 62px;
            font-size: 44px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 62px;
            margin-top: 2px;
          }
          .supply_num:hover {
            color: #00a870;
          }
          .supply_btn {
            // min-width: 105px;
            padding:0px 10px;
            height: 42px;
            line-height: 42px;
            background: #062a20;
            border-radius: 12px 12px 12px 12px;
            opacity: 1;
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #00e79a;
            margin-left: 18px;
            text-align: center;
            margin-top: 10px;
          }
          .supply_btny {
            // min-width: 105px;
            padding:0px 10px;
            height: 42px;
            line-height: 42px;
            background: #272e12;
            border-radius: 12px 12px 12px 12px;
            opacity: 1;
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #d3f85a;
            margin-left: 18px;
            text-align: center;
            margin-top: 10px;
          }
          .supply_cr {
            position: relative;
            right:4px;
            top:-10px;
            .hombottn {
              z-index: 99;
              display: flex;
              width: 100px;
              height: 44px;
              background: #242931;
              border-radius: 13px 13px 13px 13px;
              opacity: 1;
              margin-top: 20px;
              margin-right: 20px;
              div {
                height: 17px;
                height: 34px;
                font-size: 24px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #ffffff;
                line-height: 34px;
                margin-top: 4px;
                margin-left: 20px;
              }
              img {
                width: 40px;
                height: 40px;
                // margin-top: 5px;
                margin-left: 2px;
              }
            }
          }
          .headcontent {
            width: 100px;
            height: 108px;
            background: #15171a;
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            position: absolute;
            left: 0px;
            top: 64px;
            z-index: 88;
            ul {
              // margin: 12px;
              margin-left: 12px;
              li:nth-child(1) {
                margin-top: 5px;
              }
              li {
                height: 21px;
                line-height: 21px;
                cursor: pointer;
                font-size: 12px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #8e9093;
              }
              .active {
                cursor: pointer;
                color: #00a870;
              }
            }
          }
        }
      }
    }
  }
  .list {
    text-align: center;
    // padding-bottom: 80px;
    background: #13161b;
    .index_content {
      width: 750px;
      background: #13161b;
      border-radius: 0px 0px 0px 0px;
      text-align: center;
      margin: 0 auto;
      // height: 506px;
      margin-top: 34px;
      .dituzong {
        // margin-top: 24px;
        width: 702px;
        height: 506px;
        background: #000;
        border-radius: 16px 16px 0px 0px;
        margin: 0 auto;
        position: relative;
        .ditu_title {
          height: 80px;
          opacity: 1;
          margin: 0 auto;
          span {
            display: block;
            margin: 32px 0 0 32px;
            height: 80px;
            line-height: 80px;
            font-size: 32px;
            font-family: SF Pro Text-Medium, SF Pro Text;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.9);

            text-align: left;
          }
        }
        .ditu_content {
          padding-top: 8px;
          height: 378px;


          #bars {
            width: 686px;
            height: 378px;
            position: absolute;
            top: 10px;
            left: 0px;
          }
        }
      }
      .ditu_vali {
        width: 702px;
        margin: 0 auto;
        background: #000;
        border-radius: 0px 0px 0px 0px;
        display: flex;
        //border: 1px solid red;
        .vali_li {
          margin-left: 24px;
          margin-right: 60px;
          height: 39px;
          font-size: 28px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #00e79a;
          line-height: 39px;
          span {
            color: #ffffff;
            margin-left: 4px;
          }
        }
      }
      .ditu_valibox {
        width: 702px;
        height: 404px;
        background: #000;
        border-radius: 0 0 16px 16px;
        opacity: 1;
        margin: 0 auto;
        padding-top: 28px;
        .ditu_valiboxlist {
          width: 654px;
          height: 354px;
          background: #13161b;
          border-radius: 16px 16px 16px 16px;
          opacity: 1;
          margin: 0 auto;
          .ditu_tit {
            padding-top: 24px;
            margin-left: 24px;
            height: 42px;
            font-size: 30px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #8a8a8a;
            line-height: 42px;
            text-align: left;
          }

          .ditu_cont {
            display: flex;
            margin-top: 28px;
            flex-wrap: wrap;
            height: 240px;
            // border: 1px solid yellow;
            overflow: hidden;
            .ditu_conbox {
              display: flex;
              width: 289px;
              height: 80px;
             
              margin-left: 24px;
             // margin-top: 24px;
                // border: 1px solid red;
              img {
                width:48px;
                height: 48px;
                background: rgba(19, 22, 27, 0.2);
                opacity: 1;
                margin-top:12px;
              }
              div {
                height: 80px;
                font-size: 28px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 80px;
                margin-left: 18px;
                width: 140px;
                overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
                // border:1px solid red;
              }
            }
            .list {
                        // animation-name: change;
                        // animation-duration: 6s;
                        // animation-iteration-count: 1;
                      }

                      @keyframes change {
                        0% {
                          transform: translateY(-50%);
                        }
                        100% {
                          transform: translateY(0%);
                        }
                                              // 50%,
                        // 70% {
                        //   transform: translate3d(0, -66.66%, 0);
                        // }
                        // 75%,
                        // 95% {
                        //   transform: translate3d(0, -33.33%, 0);
                        // }
                      }
          }
        }
      }
    }

    .datah {
      height: 1360px !important;
    }
    .list-data {
      margin: 0px auto;
      width: 686px;
      height: 1360px;
      background: #232a35;
      border-radius: 0px 0px 16px 16px;
      opacity: 1;
      margin-bottom: 40px;
      .head {
        width: 686px;
        height: 80px;
        padding-top: 32px;
        opacity: 1;
        padding-left: 30px;
        text-align: left;
        font-size: 30px;
        font-family: "PingFang SC-中粗体, PingFang SC";
        font-weight: normal;
        color: #ffffff;
      }
      .content_center {
        text-align: left;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        line-height: 36px;
      //  border-bottom: 1px solid #3c485c;

        margin: 0px 30px;
        margin-top: 34px;
        padding-bottom: 32px;
        div {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 16px;
          height: 44px;
        }
        span:nth-child(1) {
          width: 170px;
          color: rgba(255, 255, 255, 0.55) !important;
          text-align: left;
        }
        span:nth-child(2) {
          margin-left: 32px;
        }
        span {
          padding-bottom: 10px;
          text-align: left;

          font-size: 28px;
          font-family: "PingFang SC-中黑体, PingFang SC";
          font-weight: normal;
          color: #00a870;
          line-height: 34px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 420px;
        }
        .black {
          color: rgba(255, 255, 255, 0.9);
        }
        span:nth-child(4) {
          color: rgba(255, 255, 255, 0.9) !important;
        }
        span:nth-child(5) {
          color: rgba(255, 255, 255, 0.9) !important;
        }
      }
      .button {
        margin: 50px auto;
        width: 630px;
        height: 70px;
        display: flex;
        align-content: center;
        justify-content: center;
        color: rgba(255, 255, 255, 0.55);
        .more {
          height: 24px;
          line-height: 24px;
        }
        .iconjian {
          width: 24px;
          height: 24px;
          border-top: 2px solid rgba(255, 255, 255, 0.55);
          border-right: 2px solid rgba(255, 255, 255, 0.55);
          transform: rotate(45deg);
          transform: rotate(45deg);
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.index_validators {
  width: 750px;
  // height: 572px;
  background: #13161b;
  margin: 0 auto;
  // .indexbox {
  //   width: 702px;
  //   height: 208px;
  //   background: #000000;
  //   border-radius: 24px 24px 24px 24px;
  //   opacity: 1;
  //   margin: 0 auto;
  //   display: flex;
  //   margin-bottom: 24px;
  //   justify-content: space-between;
  //   .iboxleft {
  //     margin-left: 24px;
  //     .iboxtit {
  //       margin-top: 24px;
  //       height: 34px;
  //       text-align: left;
  //       font-size: 24px;
  //       font-family: PingFang SC-Medium, PingFang SC;
  //       font-weight: 500;
  //       color: #8a8a8a;
  //       line-height: 34px;
  //       img {
  //         width: 40px;
  //         height: 40px;
  //       }
  //     }
  //     .iboxcon {
  //       height: 62px;
  //       font-size: 44px;
  //       font-family: PingFang SC-Medium, PingFang SC;
  //       font-weight: 500;
  //       color: #ffffff;
  //       line-height: 62px;
  //       margin-bottom: 24px;
  //       margin-top: 2px;
  //       text-align: left;
  //     }
  //     .iboxbottom {
  //       display: flex;
  //       .ibttol {
  //         height: 34px;
  //         font-size: 24px;
  //         font-family: PingFang SC-Medium, PingFang SC;
  //         font-weight: 500;
  //         color: #00e79a;
  //         line-height: 34px;
  //       }
  //       .ibttor {
  //         margin-left: 16px;
  //         height: 34px;
  //         font-size: 24px;
  //         font-family: PingFang SC-Regular, PingFang SC;
  //         font-weight: 400;
  //         color: #8a8a8a;
  //         line-height: 34px;
  //       }
  //     }
  //   }
  //   .iboxright {
  //     margin-right: 24px;
  //     img {
  //       margin-top: 64px;
  //       width: 84px;
  //       height: 84px;
  //     }
  //   }
  // }
}
.index_charts {
  width: 702px;
  height: 487px;
  background: #000000;
  border-radius: 24px 24px 24px 24px;
  opacity: 1;
  margin: 0 auto;
  text-align: left;
  margin-bottom: 24px;
  .charts_tit {
    height: 34px;
    font-size: 24px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #8a8a8a;
    line-height: 34px;
    padding-top: 24px;
    margin-left: 24px;
  }
  .charts_con {
    padding-top: 26px;
    margin-left: 24px;
    // height: 62px;
    font-size: 44px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    // line-height: 62px;
  }
  .charts_con:hover {
    color: #00a870;
  }
  .charts_botm {
    margin-left: 24px;
    display: flex;
    margin-top: 28px;
    .charts_l {
      .charts_lt {
        height: 34px;
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #8a8a8a;
        line-height: 34px;
      }
      .charts_lc {
        margin-top: 2px;
        height: 62px;
        font-size: 34px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 62px;
      }
      .charts_lc:hover {
        color: #00a870;
      }
    }
    .charts_c {
      margin-left: 30px;
      .charts_lt {
        height: 34px;
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #8a8a8a;
        line-height: 34px;
        img {
          width: 40px;
          height: 40px;
          margin-left: 4px;
          margin-top: -2px;
        }
      }
      .charts_lc {
        height: 62px;
        margin-top: 2px;
        font-size: 34px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 62px;
      }
      .charts_lc:hover {
        color: #00a870;
      }
    }
    .charts_r {
      position: relative;
      top: 28px;
      left: 80px;
      .hombottn {
        z-index: 99;
        display: flex;
        width: 100px;
        height: 44px;
        background: #242931;
        border-radius: 13px 13px 13px 13px;
        opacity: 1;
        margin-top: 20px;
        margin-right: 20px;
        div {
          height: 17px;
          height: 34px;
          font-size: 24px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 34px;
          margin-top: 4px;
          margin-left: 20px;
        }
        img {
          width: 40px;
          height: 40px;
          // margin-top: 5px;
          margin-left: 2px;
        }
      }
      .headcontent {
        width: 100px;
        height: 108px;
        background: #15171a;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        position: absolute;
        left: 0px;
        top: 64px;
        z-index: 88;
        ul {
          // margin: 12px;
          margin-left: 12px;
          li:nth-child(1) {
            margin-top: 5px;
          }
          li {
            height: 21px;
            line-height: 21px;
            cursor: pointer;
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #8e9093;
          }
          .active {
            cursor: pointer;
            color: #00a870;
          }
        }
      }
    }
  }
  .charts {
    width: 100%;
    // border: 1px solid red;
  }
}
.index_blocklist {
  width: 702px;
  height: 1233px;
  background: #000000;
  border-radius: 24px 24px 24px 24px;
  opacity: 1;
  margin: 0 auto;
  padding-top: 12px;
  .blocktitle {
    display: flex;
    justify-content: space-between;
    margin: 12px 24px 32px 24px;
    .block_latest {
      height: 42px;
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #8a8a8a;
      line-height: 42px;
    }
    .block_btn {
      width: 127px;
      height: 44px;
      line-height: 44px;
      background: #242931;
      border-radius: 13px 13px 13px 13px;
      opacity: 1;
      span {
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 20px;
      }

      img {
        margin-top: 4px;
        width: 40px;
        height: 40px;
      }
    }
  }
  .block_box {
    margin: 24px 24px;
    width: 654px;
    // margin: 0 auto;
    // margin-top: 24px;
    height: 258px;
    background: #13161b;
    border-radius: 16px 16px 16px 16px;
    opacity: 1;

    .block_tit {
      padding-top: 24px;
      margin-left: 24px;
      margin-right: 24px;
      display: flex;
      justify-content: space-between;
      .block_num {
        height: 62px;
        font-size: 44px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 62px;
      }
      .block_num:hover {
        color: #00a870;
      }
      .block_packer {
        height: 34px;
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #8a8a8a;
        line-height: 34px;
        span {
          margin-left: 14px;
          height: 34px;
          font-size: 24px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 34px;
        }
        span:hover {
          color: #00a870;
        }
        img {
          width: 40px;
          height: 40px;
        }
      }
    }
    .block_cont {
      margin-left: 24px;
      .block_btit {
        display: flex;
        margin-top: 18px;
        .block_time {
          height: 34px;
          font-size: 24px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #8a8a8a;
          line-height: 34px;
        }
        .block_txn {
          height: 34px;
          font-size: 24px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #8a8a8a;
          line-height: 34px;
          margin-left: 25px;
        }
      }
      .block_hash {
        // margin-left: 24px;
        width: 400px;
        overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
        text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
        white-space: nowrap; /*文本不换行*/

        height: 34px;
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #8a8a8a;
        line-height: 34px;
        text-align: left;
        margin-top: 14px;
        span {
          font-size: 24px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 34px;
          margin-left: 28px;
        }
        span:hover {
          color: #00a870;
        }
      }
      .block_tfsc {
        margin-top: 14px;
        text-align: left;
        img {
          width: 20px;
          height: 24px;
          margin-top: 10px;
        }
        span {
          height: 34px;
          font-size: 24px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #8a8a8a;
          line-height: 34px;
          margin-left: 24px;
        }
      }
    }
  }
}
</style>
